import { InfoOutlined } from '@mui/icons-material';
import { Box, BoxProps, styled } from '@mui/material';
import React from 'react';
import { IInfoBox } from '../interfaces/IInfoBox';
import CmsMaterialPredefinedIcon from './CmsMaterialPredefinedIcon';
import { PortableText } from '@portabletext/react';

const StyledBox = styled(Box)<BoxProps>(({theme}) => ({
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    background: theme?.palette?.grey?.A100,
    borderRadius: '10px'
}));

const CmsInfoTile : React.FC<IInfoBox> = ({content, muiicon}) => {
    return <StyledBox>
        <Box sx ={{padding: '0.5em',}}>
            {muiicon ? <CmsMaterialPredefinedIcon icon={muiicon}  /> : <InfoOutlined />}
        </Box>
        <Box sx={{fontSize: '0.8em', padding: '0.5em',}}>
            {content?.map((c, ci) => <PortableText key={`richtext_${ci}`} value={c} />)}
        </Box>
    </StyledBox>
}

export default CmsInfoTile;